
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class POSReturnRegisterGrid extends Serenity.EntityGrid<POSReturnRow, any> {
        protected getColumnsKey() { return 'Retail.POSReturn'; }
        protected getDialogType() { return POSReturnDialog; }
        protected getIdProperty() { return POSReturnRow.idProperty; }
        protected getInsertPermission() { return POSReturnRow.insertPermission; }
        protected getLocalTextPrefix() { return POSReturnRow.localTextPrefix; }
        protected getService() { return POSReturnService.baseUrl; }
        private chartContainer: JQuery;
        private chartPanel: Reports.LineChartPanel;
        constructor(container: JQuery) {
            super(container);

            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            this.slickGrid.setOptions({ rowHeight: 30 });
            this.addDateRangeFilter("TransDate", "Date");
            this.setTitle("");
        }

        protected getQuickFilters() {
            var filters = super.getQuickFilters();

            filters.push({
                type: Serenity.LookupEditor,
                options: {
                    lookupKey: OMS.FinancialYearRow.lookupKey,
                    multiple: true

                },
                field: 'FinancialYearId',
                title: 'Year',
                handler: w => {
                    var temp = [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push(parseInt(values[i]));
                    } if (temp.length != 0) {
                        (this.view.params as ReportFiltersRequest).FinancialYearIds = temp;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                    }
                },

                cssClass: 'hidden-xs'
            });
            filters.push({
                type: Serenity.LookupEditor,
                options: {
                    lookupKey: OMS.CompanyRow.lookupKey,
                    multiple: true

                },
                field: 'CompanyId',
                title: 'Company',
                handler: w => {
                    var temp = [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push(parseInt(values[i]));
                    } if (temp.length != 0) {
                        (this.view.params as ReportFiltersRequest).CompanyIds = temp;
                    }
                },

                cssClass: 'hidden-xs'
            });
            //filters.push({
            //    type: Serenity.LookupEditor,
            //    options: {
            //        lookupKey: "VendorLKUP",
            //        multiple: true

            //    },
            //    field: 'PartyId',
            //    title: 'Party',
            //    handler: w => {
            //        var temp = [];
            //        var values = w.value;
            //        for (var i = 0; i < values.length; i++) {
            //            temp.push(parseInt(values[i]));
            //        } if (temp.length != 0) {
            //            (this.view.params as ReportFiltersRequest).VendorIds = temp;
            //        }
            //    },

            //    cssClass: 'hidden-xs'
            //});


            return filters;
        } 
        protected getButtons(): Serenity.ToolButton[] {
            super.getButtons();
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            //buttons.push({

            //    title: 'Print',
            //    icon: 'fa fa-print text-blue',
            //    //icon: 'fa-cloud-download',
            //    onClick: () => {

            //        Common.ReportHelper.execute({
            //            reportKey: 'Reports.ApprovalRegister',
            //            params: {
            //                CompanyIds: this.view.params.CompanyIds,
            //                FinIds: this.view.params.FinancialYearIds,
            //                VendorIds: this.view.params.VendorIds,
            //                date: this.view.params.Criteria
            //            }
            //        });
            //    }
            //});
            buttons.push(Common.PdfExportHelper.createToolButton({
                grid: this,
                title: "Print",
                reportTitle: "POS Return",
                onViewSubmit: () => this.onViewSubmit()
            }));
            return buttons;
        }

    }
}